import React from 'react'
import Wwa from '../../assets/children/wwa2.png'
function OurMission() {
  return (
    <div className=' my-[64px] grid sm:grid-cols-2 px-6 sm:px-[88px]  gap-8 '>
        <div>
        <img src={Wwa} alt='WWA'/>
        </div>
        <div className=' sm:pt-9'>
        <h1 className='text-[35px] lg:text-[45px] text-[#102343] font-[700]'>
        Our Mission
        </h1>
        <p className='text-[18px] lg:text-[28px] font-[500]  mt-3'>
        To close the achievement and educational gap between privileged and less privileged children by creating a world where orphans are cared for and educated to the highest standards of academic excellence.
            <br></br><br></br>
         We aim to achieve this by providing a serene and conducive environment which will allow children to develop valuable life skills.
        </p>
        </div>
    </div>
  )
}

export default OurMission